// Buttons with data-copy put that value on the clipboard and show a check for a moment.
const copyText = (text) => {
  if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text)

  // Fallback for non-secure contexts, where the Clipboard API is unavailable
  const field = document.createElement('textarea')
  field.value = text
  field.setAttribute('readonly', '')
  field.style.position = 'absolute'
  field.style.left = '-9999px'
  document.body.appendChild(field)
  field.select()
  const copied = document.execCommand('copy')
  field.remove()
  return copied ? Promise.resolve() : Promise.reject(new Error('copy failed'))
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-copy]')
  if (!button) return

  event.preventDefault()
  const icon = button.querySelector('i')
  copyText(button.dataset.copy).then(() => {
    button.classList.add('is-copied')
    icon?.classList.replace('fa-copy', 'fa-check')
    setTimeout(() => {
      button.classList.remove('is-copied')
      icon?.classList.replace('fa-check', 'fa-copy')
    }, 1500)
  })
})
